import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  day_card_container: {},
  day_card: {},
}));

export { useStyles };
